<script setup>
import { reactiveOmit } from '@vueuse/core';
import { ChevronLeft } from '@lucide/vue';
import { RangeCalendarPrev, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';
import { buttonVariants } from '@/Components/ui/button';

const props = defineProps({
    prevPage: { type: Function, required: false },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <RangeCalendarPrev
        :class="
            cn(buttonVariants({ variant: 'outline' }), 'h-7 w-7 border-0 bg-transparent p-0 text-inherit! opacity-50 hover:opacity-100', props.class)
        "
        v-bind="forwardedProps"
    >
        <slot>
            <ChevronLeft class="h-4 w-4" />
        </slot>
    </RangeCalendarPrev>
</template>
